import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Field } from '../../../types';
import Tooltip from '../Tooltip';
import { actions } from '../../../features/quote/QuoteSlice';

export interface DateProps {
    field: Field;
    error?: string;
    onChange: any;
    selected: any;
}
function DateInput(props: DateProps) {
  const tooltip = useRef(null);
  const {
    field, error, onChange, selected,
  } = props;
  const dispatch = useDispatch();
  const [dateValue, setDateValue] = useState<any>();
  const minDate = field.vtype === 'inception' ? new Date() : null;
  const maxDate = field.vtype === 'inception' ? new Date(new Date().setDate(new Date().getDate() + 45)) : new Date();
  useEffect(() => {
    if (selected && field.vtype === 'inception') {
      setDateValue(new Date(selected));
      onChange(new Date(selected));
      dispatch(actions.updateInceptionDate(selected));
    }
    if (selected && field.vtype !== 'inception') {
      setDateValue(new Date(new Date(selected.split('/').reverse().join('/'))));
    }
  }, [selected]);

  return (
    <div className={`mb-4 form-card p-4 ${error ? 'error' : ''}`}>
      <label htmlFor={field.id} className="form-label my-2">
        {field.label}
        {field.required
                    && <span className="ms-2 d-inline-block asterix">*</span>}
      </label>
      <DatePicker
        dateFormat="dd/MM/yyyy"
        popperPlacement="bottom"
        selected={dateValue}
        minDate={minDate}
        maxDate={maxDate}
        showYearDropdown
        showMonthDropdown
        className="form-control my-2"
        dropdownMode="select"
        onChange={onChange}
      />

      <div className="form-card-footer d-flex  justify-content-between">
        {
                    error
                    && <small className="error ">{error}</small>
                }
        {field.tooltip && <Tooltip tooltipText={field.tooltip} />}
      </div>
    </div>
  );
}

DateInput.defaultProps = {
  error: false,
};

export default DateInput;
